import { APP_INITIALIZER, Provider, isDevMode } from '@angular/core';
import { HOTJAR_SETTINGS_TOKEN } from './hotjar-settings.token';
import { IHotjarSettings } from './i-hotjar-settings';

export const HOTJAR_INITIALIZER_PROVIDER: Provider = {
  provide: APP_INITIALIZER,
  multi: true,
  useFactory: HotjarInitializer,
  deps: [
    HOTJAR_SETTINGS_TOKEN
  ]
};

export function HotjarInitializer(
  $settings: IHotjarSettings
) {
  return async () => {
    if (!$settings.trackingCode) {
      if (!isDevMode()) {
        console.error('Empty tracking code for Hotjar. Make sure to provide one when initializing HotjarModule.');
      }

      return;
    }

    (function(h: any, o: any, t: any, j: any, a?: any, r?: any) {
      h.hj = h.hj || function() {
        (h.hj.q = h.hj.q || []).push(arguments);
      };

      h._hjSettings = { hjid: $settings.trackingCode, hjsv: $settings.version || 6 };
      a = o.getElementsByTagName('head')[0];

      r = o.createElement('script');
      r.async = 1;
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;

      a.appendChild(r);

    })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
  };
}